import React from 'react';
import { useIntl } from 'react-intl';
import copy from 'copy-to-clipboard';
import styles from '../styles';
import {
  Button,
  Dialog,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  withStyles,
  FormLabel,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import { getI18n, getI18nFormattedMessage } from '../../../../../utils/intl';
import { FormTextField } from '../../../../../components';
import { ALERT_SUCCESS } from '../../../../../constants';
import { compose } from 'recompose';
import { bool, func, object, string } from 'prop-types';
export const RegisterClientInfoDialog = (props) => {
  const {
    isRegisteredKeyInfoDialogOpen,
    classes,
    registeredClientId,
    keyClientSecret,
    notifyMessages,
    clientMetadata,
  } = props;
  const intl = getI18n(useIntl());
  const showCopied = (value, valueType, notifyMessages) => {
    let strType = '';
    if (valueType === 'API_KEY') {
      strType = 'API Key';
    } else if (valueType === 'SECRET') {
      strType = 'Secret';
    }
    notifyMessages(`${strType}: ${value} was copied to the clipboard.`, ALERT_SUCCESS, true);
  };

  const handleCloseDialogClick = () => {
    props.setIsRegisteredKeyInfoDialogOpen(false);
    if(props.onRegistrationDialogClose()) {
      props.onRegistrationDialogClose();
    }
  };
  
  return (
    <Dialog
      open={isRegisteredKeyInfoDialogOpen}
      onClose={() => {
        props.setIsRegisteredKeyInfoDialogOpen(false)
      }}
      aria-labelledby="registered-key-info-dialog"
      id="registered-key-info-dialog"
      data-apim-test={"registered-key-info-dialog"}
      classes={{
        paper: classes.registrationInfoPaper,
      }}
    >
      <div className={classes.generateSecretDialog}>
        <h3>{intl.getI18nFormattedMessage('label.application.details.keys.key.generate.secret.dialog.heading')}</h3>
        <div className={classes.fieldCopyContainer}>
          <FormTextField
            id={`registered-key-clientid-${registeredClientId}`}
            name={intl.getI18nMessage('label.application.key')}
            value={registeredClientId}
            fieldContainerClass={classes.dialogTextField}
            disabled
            errorHelperText={false}
            helperText={''}
          />
          <Button
            variant="outlined"
            onClick={() => {
              copy(registeredClientId);
              showCopied(registeredClientId, 'SECRET', notifyMessages);
            }}
            className={classes.copyButton}
            >
            {getI18nFormattedMessage('label.application.details.keys.overview.copy.button')}
          </Button>
        </div>
        <div className={classes.fieldCopyContainer}>
          <FormTextField
            id={`registered-key-${keyClientSecret}`}
            name={intl.getI18nMessage('label.application.key.shared.secret')}
            value={keyClientSecret}
            fieldContainerClass={classes.dialogTextField}
            disabled
            errorHelperText={false}
            helperText={''}
          />
          <Button
            variant="outlined"
            onClick={() => {
              copy(keyClientSecret);
              showCopied(keyClientSecret, 'SECRET', notifyMessages);
            }}
            className={classes.copyButton}
            >
            {getI18nFormattedMessage('label.application.details.keys.overview.copy.button')}
          </Button>
        </div>
        <div className={classes.secretHelpText}>
            <WarningIcon className={classes.secretInfoWarningIcon}/>
            <Typography>
              {intl.getI18nFormattedMessage('label.application.key.shared.secret.hashed.generated.help')}
            </Typography>
        </div>
        <div id={`client-metadata-expand-collapse-button`}>
          <Accordion>
            <AccordionSummary
               expandIcon={<ArrowDownwardIcon />}
               aria-controls="panel1-content"
               id="panel1-header">
                <FormLabel>{intl.getI18nFormattedMessage('label.application.details.keys.key.register.clientmetadata')}</FormLabel>
            </AccordionSummary>
            <AccordionDetails className={classes.metaDataAccordion} >
               <Typography
                 component="pre">
                    {JSON.stringify(clientMetadata, null, 2)}
               </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className={classes.dialogButtonPanel}>
          <Button
            color="primary"
            data-apim-test={"registered-key-info-dialog-close-btn"}
            variant="outlined"
            onClick={handleCloseDialogClick}
            className={classes.cancelButton}
          >
          {intl.getI18nFormattedMessage('label.close.button')}
          </Button>
        </div>
      </div>
    </Dialog>);
};
RegisterClientInfoDialog.propTypes = {
  classes: object,
  registeredClientId: string,
  keyClientSecret: string,
  clientMetadata: string,
  notifyMessages: func,
  isRegisteredKeyInfoDialogOpen: bool,
  setIsRegisteredKeyInfoDialogOpen: func,
  onRegistrationDialogClose: func,
}
export default compose(
  withStyles(styles),
)(RegisterClientInfoDialog);